import {clientFieldsService} from "../services/clientFieldsService";
import {settingsService} from "../services/settingsService";
import {postMessageService} from "@/modules/common/services";
import Vue from 'vue';

const state = {
  intakeForms: null,
  allFields: [],
  clientFields: [],
  matterFields: [],
  deletedMatterFields: [],
  mergedFields: [],
  clientFieldTypes: null,
  fullContactSettings:{
    full_contact_on: null
  },
  businessPolicy:{
    meetings_policy: null,
    payments_policy: null,
    messages_policy: null
  },
  termsOfService:{
    tos_url: null,
    require_tos: null
  },
  clientStatusSettings:{
    after_first_booking: null,
    after_first_invoice: null,
    after_first_payment: null,
    status_automation_lead_to_customer: null
  },
  clientStatuses: [],
  customStatuses: [],
  fieldsPromise: null
};

const getters = {
  allFields: state => {
    return state.allFields
  },
  clientFields: state => {
    return state.clientFields
  },
  matterFields: state => {
    return state.matterFields
  },
  deletedMatterFields: state => {
    return state.deletedMatterFields
  },
  clientFieldTypes: state => {
    return state.clientFieldTypes
  },
  clientStatusSettings: state => {
    return state.clientStatusSettings
  },
  termsOfService: state => {
    return state.termsOfService
  },
  businessPolicy: state => {
    return state.businessPolicy
  },
  fullContactSettings: state => {
    return state.fullContactSettings
  },
  intakeForms: state => {
    return state.intakeForms
  },
  clientStatuses: state => state.clientStatuses,
  customStatuses: state => state.customStatuses,
  allStatuses: state => state.clientStatuses.concat(state.customStatuses),
  mergedFields: state => state.mergedFields,
  mergedContactFields: state => state.mergedFields.filter(field => field.object_type === 'contact'),
  hasOptInField: state => state.clientFields && state.clientFields.findIndex(field => field.type === 'opt-in') !== -1
};

const mutations = {
  setIntakeForms : (state,intakeForms) => {
    state.intakeForms = intakeForms
  },
  setIntakeForm : (state,payload) => {
    state.intakeForms[payload[1]] = payload[0]
  },
  setClientFields : (state,fields) => {
    state.allFields = fields;
    state.clientFields = fields.filter(field => !field.deleted)
    state.matterFields = fields.filter(field => field.object_type === 'matter' && !field.deleted)
    state.deletedMatterFields = fields.filter(field => field.object_type === 'matter' && field.deleted)
  },
  setMergedFields: (state, mergedFields) => {
    state.mergedFields = mergedFields;
  },
  setClientFieldTypes : (state,clientFieldTypes) => {
    state.clientFieldTypes = clientFieldTypes
  },
  setClientStatusSettings : (state,clientStatusSettings) => {
    state.clientStatusSettings.after_first_booking = clientStatusSettings.after_first_booking
    state.clientStatusSettings.after_first_invoice = clientStatusSettings.after_first_invoice
    state.clientStatusSettings.after_first_payment = clientStatusSettings.after_first_payment
    state.clientStatusSettings.status_automation_lead_to_customer = clientStatusSettings.status_automation_lead_to_customer
  },
  setTermsOfService : (state,termsOfService) => {
    state.termsOfService = termsOfService
  },
  setBusinessPolicy : (state,businessPolicy) => {
    state.businessPolicy = businessPolicy
  },
  setFullContactSettings : (state,fullContactSettings) => {
    state.fullContactSettings.full_contact_on = fullContactSettings.full_contact_on
  },
  setClientStatuses: (state, {statuses, custom_statuses}) => {
    state.clientStatuses = statuses
    state.customStatuses = custom_statuses
  },
  setClientStatus: (state, {id, display_value}) => {
    const idx = state.clientStatuses.findIndex(item => item.id === id)
    if (idx === -1) return

    const curr = state.clientStatuses[idx]
    curr.display_value = display_value
    Vue.set(state.clientStatuses, idx, curr)
  },
  addCustomStatus: (state, {status}) => {
    state.customStatuses.push(status)
  },
  removeCustomStatus: (state, {id}) => {
    state.customStatuses = state.customStatuses.filter(item => item.id !== id)
  },
  addFieldType : (state,fieldType) => {
    let fieldTypeData = clientFieldsService.getClientFieldType(fieldType)
    if(fieldTypeData){
      fieldType.icon = fieldTypeData['icon'];
      fieldType.can_be_deleted = fieldTypeData['can_be_deleted'];
      fieldType.can_be_removed = fieldTypeData['can_be_removed'];
    }
    state.clientFields.push(fieldType)
  },
  editFieldType : (state,fieldType) => {
    const idToBeEdited = _.findIndex(state.clientFields, function(o) { return o.id == fieldType.id; })
    if(idToBeEdited){
      state.clientFields[idToBeEdited] = fieldType
    }
  },
  removeFieldType : (state,fieldTypeToBeRemoved) => {
    const idToBeRemoved = _.findIndex(state.clientFields, function(o) { return o.id == fieldTypeToBeRemoved.id; })

    if(idToBeRemoved){
      state.clientFields.splice(idToBeRemoved, 1)
    }
  },
  setFieldsPromise: (state, promise) => {
    state.fieldsPromise = promise;
  }
};

const actions = {
  updateTermsOfService: async ({commit},termsOfService) => {

    let data = {
      tos_url: termsOfService.tos_url,
      require_tos: termsOfService.require_tos
    }
    let result = await settingsService.update(data)
    if(result){
      commit('setTermsOfService', data)
    }
  },
  updateBusinessPolicy: async ({commit},businessPolicy) => {
    let result = await settingsService.update(businessPolicy)
    if(result){
      commit('setBusinessPolicy', businessPolicy)
    }
  },
  updateFullContactSettings: async ({commit},fullContactSettings) => {
    let result = await settingsService.update(fullContactSettings)
    if(result){
      commit('setFullContactSettings', fullContactSettings)
    }
  },
  updateClientStatusSettings: async ({commit},clientStatusSettings) => {
    let result = await settingsService.updateNotificationSettings(clientStatusSettings)
    if(result){
      commit('setClientStatusSettings', clientStatusSettings)
    }
    return 'success'
  },
  addFieldType: async ({commit},field) => {
    let optInResult = null
    let fieldResult = await clientFieldsService.addField(field)
    if(field.enforce_opt_in){
       optInResult = await settingsService.update({  'enforce_opt_in' : true})
    }else{
      optInResult = true
    }

    if(fieldResult && !fieldResult.error && optInResult){
      commit('addFieldType', field)
    }
    return fieldResult
  },
  editFieldType: async ({commit},field) => {

    let fieldResult = await clientFieldsService.editField(field)
    let optInResult = await settingsService.update({  'enforce_opt_in' : field.enforce_opt_in})
    if(fieldResult && !fieldResult.error && optInResult){
      commit('editFieldType',field)
    }
    return fieldResult
  },
  reOrderFields: async ({commit},fields) => {
    let result = await clientFieldsService.reOrderFields(fields)
    return result
  },
  deleteFieldType: async ({commit},field) => {

    let result = await clientFieldsService.deleteField(field)
    if(result){
      commit('removeFieldType', field)
    }
    return result
  },
  fetchClientFields: async ({commit, rootState, state}, payload) => {
    if ((!payload || !payload.refresh) && state.fieldsPromise) {
      return state.fieldsPromise;
    }

    const promise = clientFieldsService.getFields().then(fields => {
      commit('setClientFields', fields);

      if (rootState.accountModule.profile) {
        const mergedFields = fields.map(field => {
          const accountField = rootState.accountModule.profile.client_fields.find(f => f.uid === field.id);
          return {...field, id: accountField && accountField.id, uid: field.id};
        });

        commit('setMergedFields', mergedFields);
      }
    }, error => {
      console.error("fetchClientFields", error);
    });

    commit('setFieldsPromise', promise);
    return promise;
  },
  refreshClientFields: async ({dispatch}) => {
    await dispatch({type: "fetchClientFields", refresh: true});
  },
  fetchClientFieldTypes: async ({commit}, payload) => {
    try {
      commit('setClientFieldTypes', clientFieldsService.clientFieldTypes)
    } catch (e) {
      console.log("fetchFieldTypes", e)
    }
  },
  fetchClientStatusSettings: async ({commit}, payload) => {
    try {
      const settings = await settingsService.get()
      commit('setClientStatusSettings', settings)
    } catch (e) {
      console.log("fetchClientStatusSettings", e)
    }
  },
  fetchFullContactSettings: async ({commit}, payload) => {
    try {
      const settings = await settingsService.get()
      commit('setFullContactSettings', settings)
    } catch (e) {
      console.log("fetchFullContactSettings", e)
    }
  },
  fetchIntakeForms : async ({commit}, payload) => {
    try {
      let intakeForms = await clientFieldsService.getForms()
      intakeForms.shift()
      commit('setIntakeForms', intakeForms)
    } catch (e) {
      console.log("fetchIntakeForms", e)
    }
  },
  fetchBusinessPolicy : async ({commit}, payload) => {
    try {
      let businessPolicy = await settingsService.get()
      commit('setBusinessPolicy', businessPolicy)
    } catch (e) {
      console.log("fetchBusinessPolicy", e)
    }
  },
  fetchClientStatuses: async ({commit}) => {
    const res = await clientFieldsService.getClientStatuses()
    if (res.status !== "OK") return
    commit('setClientStatuses', res)
    return res
  },
  updateClientStatus: async ({commit}, {data}) => {
    const {id, display_value} = data
    await clientFieldsService.updateClientStatus(id, display_value)
    commit('setClientStatus', {id, display_value})
    postMessageService.post('reload-account')
  },
  addCustomStatus: async ({commit}, {label}) => {
    const res = await clientFieldsService.addCustomStatus(label)
    commit('addCustomStatus', {status: res})
    postMessageService.post('reload-account')
  },
  removeCustomStatus: async ({commit}, {id}) => {
    await clientFieldsService.removeCustomStatus(id)
    commit('removeCustomStatus', {id})
    postMessageService.post('reload-account')
  },
  updateFieldSet : async ({commit},form) => {

    let result = await clientFieldsService.updateIntakeForm(form)
    if(result){
      let formIndex =  _.findIndex(state.intakeForms, function(o) { return o.type == form.type; })
      commit('setIntakeForm', [form,formIndex])
    }
    return result
  },
  updateFieldInForm: async ({commit}, field) => {
    await clientFieldsService.updateFieldInForm(field)

    return true;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
